import Axios from 'axios';
import baseUrlHelper from '@/helpers/baseUrlHelper';
import snackbarNotificationConstants from '@/store/modules/snackbarNotification/constants';
import authConstants from '@/store/modules/auth/constants';

export default {
  configureAxios(store, router) {
    const isProduction = process.env.NODE_ENV === 'production';

    Axios.defaults.baseURL = baseUrlHelper.apiBaseUrl;
    Axios.defaults.withCredentials = true;

    if (!isProduction) {
      Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    }

    Axios.defaults.headers.common.Pragma = 'no-cache';

    Axios.interceptors.response.use(response => response, (error) => {
      const isValidationError = error.response && error.response.status === 400;
      const isAuthorizationError = error.response && error.response.status === 401;
      const isAccessError = error.response && error.response.status === 403;

      if (!isValidationError && !isAuthorizationError && !isAccessError) {
        store.dispatch(`snackbarNotification/${snackbarNotificationConstants.actionTypes.error}`, 'An error ocured. We are unable to handle you request now.');
      }

      if (isAccessError) {
        store.dispatch(`snackbarNotification/${snackbarNotificationConstants.actionTypes.error}`, 'You have not enough permissions to perform this action.');
      }

      if (isAuthorizationError) {
        store.dispatch(`auth/${authConstants.actionTypes.clearAuthInfo}`);

        if (router.history.current.meta.requiresAuth) {
          router.push({ name: 'login', query: { from: router.history.current.fullPath } });
        }
      }

      return Promise.reject(error);
    });
  },
};
